import { render, staticRenderFns } from "./AccountDelete.vue?vue&type=template&id=1bb38c19&scoped=true&"
import script from "./AccountDelete.vue?vue&type=script&lang=js&"
export * from "./AccountDelete.vue?vue&type=script&lang=js&"
import style0 from "./AccountDelete.vue?vue&type=style&index=0&id=1bb38c19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb38c19",
  null
  
)

export default component.exports